module.exports = __webpack_public_path__ + "img/icon-instagram.2fe08e44.svg";